module.exports = __webpack_public_path__ + "static/media/Y-Ship-Cloud-Getting-Started-Buyma.b3248d5c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/files/Y-Ship-Cloud-Getting-Started-Buyma.pdf
// module id = 815
// module chunks = 0